import React from 'react';
import AlertMessage from '../AlertMessage';

/**
 * Displays a message that the current order has been accessioned
 */
export default function AccessionedOrderAlert(props) {
	return (
		<AlertMessage type="warning">
			<strong>
				This order has been received by our lab and no more changes can be made. If you need to update your
				information, please call us at <span className="text-nowrap">{props.isUKOrder ? process.env.REACT_APP_UK_CUSTOMER_CARE_NUMBER : process.env.REACT_APP_CUSTOMER_CARE_NUMBER}</span>.
			</strong>
		</AlertMessage>
	);
}
